import { FC } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

interface ViewerWaitingProps {
    avatar: string;
    username: string;
    index: number;
}

const ViewerWaitingItem: FC<ViewerWaitingProps> = ({ avatar, index, username }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <img
            className={clsx(classes.avatar, index > 0 ? classes.extraNegativeMargin : '')}
            src={avatar}
            alt={t('{{username}} user waiting for turn', { username })}
        />
    );
};

export default ViewerWaitingItem;
